import React from "react";
import { Button } from "../../../common/u1/Button";
import { SuccessMark } from "../../../common/u1/SuccessMark";

/* ICC-11 — the dispute is logged as a support ticket. Nothing has changed
   hands, so this screen promises a conversation, not an outcome. */
export const DisputeSubmittedStep = ({
  companyName = "",
  contactEmail = "",
  ticketId,
  onBackToProfile,
  onHelp,
}) => (
  <div className="py-5 text-center" role="status">
    <SuccessMark />

    <h2 className="mt-[18px] text-[24px] font-bold tracking-[-0.02em] text-[var(--ink)] font-sans">
      Thank you — we have your dispute
    </h2>

    <p className="mx-auto mt-2.5 max-w-[480px] text-[14px] leading-[1.55] text-[var(--ink-2)] font-sans">
      Our support team will review your dispute
      {companyName ? <> for <b>{companyName}</b></> : null} and contact you
      {contactEmail ? <> at <b>{contactEmail}</b></> : null}.
    </p>

    {ticketId ? (
      <p className="mx-auto mt-3 max-w-[480px] text-[13px] text-[var(--muted)] font-sans">
        Your ticket reference is <b>#{ticketId}</b>. Quote it if you need to add
        anything.
      </p>
    ) : null}

    {(onBackToProfile || onHelp) && (
      <div className="mt-[22px] flex flex-col items-stretch justify-center gap-2.5 sm:flex-row sm:items-center">
        {onBackToProfile && (
          <Button variant="outline" onClick={onBackToProfile} className="h-[46px] px-5">
            Back to company profile
          </Button>
        )}
        {onHelp && (
          <Button onClick={onHelp} className="h-[46px] px-5">
            Go to Help &amp; Support
          </Button>
        )}
      </div>
    )}
  </div>
);

export default DisputeSubmittedStep;
